// import queryString from "query-string";
import React, { useContext } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import {
  ICityItem,
  IItem,
  IProvinceItem,
} from "../../../../types/common.interface";
import utils from "../../../../utils";
import { ICreateAndUpdateMunicipality } from "../../../../types/municipality.interface";

const FilterAgent = () => {
  // ============================== Value Validation ================================

  //   const {search} = queryString.parse(window.location.search);
  const [effect, setEffect] = React.useState(false);
  const [selectedFilters, setSelectedFilters] = React.useState<any>({
    // isBlock,
    // isApproved,
    // province,
    // city,
  });

  const { requestCompany, setRequestCompany } = useContext(
    Context.CompanyScreen
  );

  const userType = utils.stringHexConversion?.reverse(
    Cookies.get(constants?.USER?.TYPE)
  );

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllMunicipality = useQuery(
    [values.useQueryKeys.getAllMunicipality],
    () => api.postMethod.administrator.getAllMunicipality({})
  );

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================
  // ================================ UseEffect Call ===============================

  // ================================== JSX Content ================================

  return (
    <div className="filter-container">
      <CustomDropdownFilter title="مرتب سازی براساس">
        {userType === "ADMIN" && (
          <>
            <p className="filter-labels">شهرداری:</p>
            <CustomDropdownSearch
              items={getAllMunicipality?.data?.result}
              itemName="name"
              defaultItem={requestCompany?.filters?.municipality}
              onSelectItem={(event: ICreateAndUpdateMunicipality) =>
                setRequestCompany!({
                  ...requestCompany,
                  filters: {
                    ...requestCompany?.filters,
                    municipality: event,
                  },
                })
              }
              placeHolder="انتخاب شهرداری"
              isLoading={getAllMunicipality.isLoading}
            />
          </>
        )}
        <div className="filter-footer">
          <CustomButton2
            title="تنظیم مجدد"
            onClick={() => {
              setRequestCompany!({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

const gender: IItem[] = [
  { name: "مرد", value: "MALE" },
  { name: "زن", value: "FEMALE" },
];
const marital: IItem[] = [
  { name: "مجرد", value: "SINGLE" },
  { name: "متاهل", value: "MARRIED" },
];

export default FilterAgent;
